"use strict";const e={defaultSnapshot:"/snapshot/",employeeSummary:"/snapshot/header/",hoverCard:"/hovercard"};exports.ROUTES=e;
//# sourceMappingURL=constants-NyctOMvp.js.map
